import { ITableRow } from 'modules/admin-panel/pages/results/models';
import { STATISTIC_DATA_GLOBAL_NAME } from 'modules/admin-panel/pages/results/utils';
import { ITableService } from 'modules/admin-panel/pages/results/models/StaticTableColumns';

export const sortStatisticData = (
	data: ITableRow[] | undefined,
	activeServiceName: string,
	decreasing: boolean,
): ITableRow[] | undefined => {
	if (!data) return;

	return data
		.sort((a, b) => {
			if (!activeServiceName) return 0;
			if (!a || !a[activeServiceName]) return 0;
			if (!b || !b[activeServiceName]) return 0;
			if (
				a.name.value === STATISTIC_DATA_GLOBAL_NAME ||
				b.name.value === STATISTIC_DATA_GLOBAL_NAME
			)
				return 0;

			const valueA = (a[activeServiceName] as ITableService<number>).value;
			const valueB = (b[activeServiceName] as ITableService<number>).value;

			return decreasing ? valueB - valueA : valueA - valueB;
		})
		.map((i) => {
			if (i.statistics) {
				return {
					...i,
					statistics: sortStatisticData(
						i.statistics,
						activeServiceName,
						decreasing,
					),
				};
			}
			return i;
		});
};
